import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { FramingBand } from '../components/FramingBand';
import { ProblemSection } from '../components/ProblemSection';
import { PlatformOverview } from '../components/PlatformOverview';
import { OperatingModel } from '../components/OperatingModel';
import { CapabilityDomains } from '../components/CapabilityDomains';
import { HumanOpportunity } from '../components/HumanOpportunity';
import { LifecycleArchitecture } from '../components/LifecycleArchitecture';
import { Solutions } from '../components/Solutions';
import { ProductEcosystem } from '../components/ProductEcosystem';
import { GlobalArchitecture } from '../components/GlobalArchitecture';
import { LeadershipReadiness } from '../components/LeadershipReadiness';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
export function HumanCapabilityPage() {
  return <>
      <HeroSection data-id="element-1742" data-mp="hmqee383hnr8" />
      <FramingBand data-id="element-1743" data-mp="hn9k8lkh0low" />
      <ProblemSection data-id="element-1744" data-mp="hnrrsecl2mc4" />
      <PlatformOverview data-id="element-1745" data-mp="3g40c3naddg6s" />
      <OperatingModel data-id="element-1746" data-mp="3g4i94m4uvyfr" />
      <CapabilityDomains data-id="element-1747" data-mp="3g5bepjs2whwb" />
      <HumanOpportunity data-id="element-1748" data-mp="3k522rfq80jx5" />
      <LifecycleArchitecture data-id="element-1749" data-mp="3k4k5qgvqi1o6" />
      <Solutions data-id="element-1750" data-mp="3k5lkowfvf8b6" />
      <ProductEcosystem data-id="element-1751" data-mp="3k2zdwz0t0wu0" />
      <GlobalArchitecture data-id="element-1752" data-mp="3p455gtiqae1y" />
      <LeadershipReadiness data-id="element-1753" data-mp="3p3ws70ip16q8" />
      <FAQ data-id="element-1754" data-mp="3p2lu9hbxit71" />
      <FinalCTA data-id="element-1755" data-mp="3p228tqn2lmo9" />
    </>;
}